// extracted by mini-css-extract-plugin
export default {"labelRow":"labelRow---FE43b","label":"label---rV27m"};